import { updateStatuses } from '../statuses';
import * as types from '../actions/actionTypes';
import { isUndefinedNullOrEmpty } from '../utils';

export function asyncActionCreator(requestActionType, requestPromise, jsonToValue, extraActionDetails = {}) {

    function onSuccess(value, totalCount = null) {
        return {
            ...extraActionDetails,
            type: requestActionType,
            value: value,
            statusUpdateTime: new Date(),
            updateStatus: updateStatuses.success,
            totalCount: totalCount || null,
            error: {
                userMessage: '',
                technicalContext: ''
            }
        };
    }

    function onAppFailure(userMessage, technicalContext) {
        return {
            type: types.APP_ERROR,
            time: new Date(),
            error: {
                userMessage: userMessage,
                technicalContext: technicalContext
            }
        };
    }

    function onFailure(userMessage, technicalContext) {
        return {
            ...extraActionDetails,
            type: requestActionType,
            statusUpdateTime: new Date(),
            updateStatus: updateStatuses.failure,
            totalCount: null,
            error: {
                userMessage: userMessage,
                technicalContext: technicalContext
            }
        };
    }

    return (dispatch) => {
        dispatch({ type: requestActionType, updateStatus: updateStatuses.requested, ...extraActionDetails });

    return requestPromise.then((response) => {
        switch (response.status) {
            case 200:
            case 201:
            case 202:
                return response.json().then(json => {
                    const value = jsonToValue(json, response.status, response.headers);
                    dispatch(onSuccess(value, json.totalCount));
                    return value;
                });
            
            case 204:
                return;

            case 403:
                const userMessage = 'Access denied, the user is not a member of the permitted Windows security group';
                dispatch(onAppFailure(userMessage));
                dispatch(onFailure(userMessage));
                throw {
                    message: userMessage,
                    statusCode: response.status
                };

            case 409:
                return response.json().then(json => {
                    throw {
                        message: json.message,
                        statusCode: response.status
                    };
                });

            default:
                const status = response.status;
                const technicalContext = requestActionType + ' returned ' + status;

                if (!response.json) {
                    dispatch(onAppFailure(technicalContext, technicalContext));
                    dispatch(onFailure(technicalContext, technicalContext));
                    throw {
                        message: technicalContext,
                        statusCode: status
                    };
                } else {
                    return response.json().then(json => {
                        const userMessage = json.ExceptionMessage || json.message || json.Message || JSON.stringify(json);
                        if (json.StackTrace) {
                            console.log(json.StackTrace);
                        }
                        dispatch(onAppFailure(userMessage, technicalContext));
                        dispatch(onFailure(userMessage, technicalContext));
                        throw {
                            message: isUndefinedNullOrEmpty(userMessage) ? technicalContext : userMessage,
                            statusCode: status
                        };
                    });
                }
        }
    }).catch((err) => {
        const technicalContext = `${requestActionType} failed`;
        dispatch(onAppFailure(err.message, technicalContext));
        dispatch(onFailure(err.message, technicalContext));

        throw err;
    });
};
};



// WEBPACK FOOTER //
// ./src/js/actions/asyncActionCreatorFactory.js